import PropTypes from 'prop-types';
import Icon from '../icon';

export function SearchButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      title="Submit search"
      type="button"
    >
      <Icon.Search className="search-icon" />
    </button>
  );
}

SearchButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
